// Import model
import { StartContactAddAppointmentRequest } from '../models/StartContactAddAppointmentRequest';

// Import base class serializer

// Import dependency types (models and enums used in properties)

// Import dependency serializers (for complex types)

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for StartContactAddAppointmentRequest - handles JSON serialization and deserialization with type validation
 */
export class StartContactAddAppointmentRequestSerializer {
  /**
   * Deserializes a JSON string into a StartContactAddAppointmentRequest instance
   */
  static deserialize(json: string): StartContactAddAppointmentRequest {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a StartContactAddAppointmentRequest instance
   */
  static fromObject(obj: any): StartContactAddAppointmentRequest {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to StartContactAddAppointmentRequest');
    }


    const instance: StartContactAddAppointmentRequest = {
      start: obj['Start'] as string | undefined,
      userId: obj['UserId'] as string | undefined,
      name: obj['Name'] as string | undefined,
      description: obj['Description'] as string | undefined,
      message: obj['Message'] as string | undefined,
      sendEmail: obj['SendEmail'] as boolean | undefined,
      duration: obj['Duration'] as string | undefined,
      copyAddress: obj['CopyAddress'] as boolean | undefined,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of StartContactAddAppointmentRequest instances
   */
  static deserializeArray(json: string): StartContactAddAppointmentRequest[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a StartContactAddAppointmentRequest instance to a JSON string
   */
  static serialize(instance: StartContactAddAppointmentRequest): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a StartContactAddAppointmentRequest instance to a plain object
   */
  static toObject(instance: StartContactAddAppointmentRequest): any {
    return {
      'Start': instance.start,
      'UserId': instance.userId,
      'Name': instance.name,
      'Description': instance.description,
      'Message': instance.message,
      'SendEmail': instance.sendEmail,
      'Duration': instance.duration,
      'CopyAddress': instance.copyAddress,
    };
  }

  /**
   * Serializes an array of StartContactAddAppointmentRequest instances to a JSON string
   */
  static serializeArray(instances: StartContactAddAppointmentRequest[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
